import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  DeductibleRequestInterface,
  DeductibleResponseInterface,
  Group
} from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class DeductibleService {
  constructor() {}

  searchDeductibles(
    query: DeductibleRequestInterface,benefitList:Group
  ): Observable<DeductibleResponseInterface> {
    const response: DeductibleResponseInterface = benefitList[0];
    return of(response);
  }
}
